import React from 'react';

import { Header } from '../header/Header';
import { Content } from '../content/Content';
import { Keyboard } from '../../components/keyboard/Keyboard';
import useKeyboard from '../../contexts/keyboard/KeyboardContext';


export const Main = (): React.ReactElement => {
  const keyboardContext = useKeyboard()

  return <div className="h-full flex flex-col">
    <Header/>
    <Content/>
    {keyboardContext.opened && <Keyboard/>}
  </div>
}
